import React from "react";
import { Toolbar, Grid, Box, createTheme, useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import { muiV4Breakpoints } from "../utils/constants";

const FilterToolbar = ({
  isSmall,
  canCreate,
  leftSection,
  middleSection,
  rightSection,
  combinedActions,
  leftGridProps = { xs: 12, md: 1 },
  rightGridProps = { xs: 12, md: 1 },
}) => {
  const outerTheme = useTheme();
  const theme = createTheme({
    ...outerTheme,
    breakpoints: muiV4Breakpoints,
  });
  const isXtraLarge = useMediaQuery(theme.breakpoints.up("xl"));
    
  const middleGridProps = {
    xs: 12,
    md: canCreate ? (isXtraLarge ? 9 : 10) : isXtraLarge ? 10 : 11,
  };
  return (
    <Toolbar
      disableGutters
      sx={{ flexDirection: "column", alignItems: "stretch", gap: 2 }}
    >
      <Grid
        container
        spacing={2}
        alignItems="stretch"
        sx={{
          display: "flex",
        }}
      >
        {canCreate && (
          <Grid
            item
            {...leftGridProps}
            sx={{
              display: isSmall ? "none" : "flex",
              flexDirection: "column",
            }}
          >
            <Box sx={{ height: "100%", width: "100%" }}>{leftSection}</Box>
          </Grid>
        )}

        <Grid
          item
          {...middleGridProps}
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ height: "100%", width: "100%" }}>{middleSection}</Box>
        </Grid>

        <Grid
          item
          {...rightGridProps}
          sx={{
            display: isSmall ? "none" : "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ height: "100%", width: "100%" }}>{rightSection}</Box>
        </Grid>
      </Grid>

      {isSmall && combinedActions && (
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          {combinedActions}
        </Box>
      )}
    </Toolbar>
  );
};

export default FilterToolbar;
